export default "__VITE_ASSET__C2sl3d6z__"